import React, { useState, useEffect } from 'react'
import { Table, Icon, Whisper, Tooltip } from 'rsuite'
import { useHistory } from 'react-router-dom'
import './styles.less'
import { budgetFormat } from '../../utils/formatterUtil'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import WarningDetailWidgets from '../mainIncomAndExpenseWidgets/WarningDetailWidgets'
import { sessionGetItemStr } from '../../utils/sessionHelpers'

export default function ProjectBasedItemsTable({
  schema,
  dataKeyTable,
  pagination,
  loading,
  hiddenColStatus,
  onSearchCommittee,
  onEdit,
  onDownload,
  onDelete,
  expand: _expand,
  onSelect,
  onSelectPeriodicManagement,
  disabled,
  onReload = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [isShowModalWarning, setIsShowModalWarning] = useState(false)
  const [warningProjectCode, setWarningProjectCode] = useState()
  const [warningPeriodNumber, setWarningPeriodNumber] = useState()

  const fs = localStorage.getItem('fontSize')
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }

  useEffect(() => {
    setTableData(schema)
  }, [schema])

  const TagCell = ({ rowData, dataKey, ...props }) => {
    // console.log('row data => ', rowData)
    let bgColor = ''
    if (rowData.periodStatusColor) {
      bgColor = rowData.periodStatusColor
    } else {
      bgColor = '#a7aaaa'
    }

    return (
      <Cell {...props}>
        <div
          className="tag"
          style={{
            backgroundColor: bgColor,
          }}
        >
          <span className="tag__text">{rowData[dataKey]}</span>
        </div>
      </Cell>
    )
  }

  const handleShowWarningDetail = (rowData) => {
    const projectCode = sessionGetItemStr('projectCode')
    console.log('handleShowWarningDetail => ', projectCode, rowData)

    setWarningProjectCode(projectCode)
    setWarningPeriodNumber(rowData.periodNumber)
    setIsShowModalWarning(true)
  }

  return (
    <>
      <Table
        wordWrap
        autoHeight
        loading={loading}
        data={tableData}
        style={{ marginTop: '20px' }}
        className="table-all-project"
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
      >
        <Column width={120} align="center">
          <HeaderCell style={{ ...styleHeaderCell }}>งวด</HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.periodNo) {
                return `${rowData.periodNo}`
              } else {
                return ''
              }
            }}
          </Cell>
        </Column>

        <Column width={120} minWidth={120} align="center">
          <HeaderCell style={{ ...styleHeaderCell }}></HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isDisplayWarning == 'YES') {
                return (
                  <>
                    {/* {rowData.startAndEndDate}{' '} */}
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={
                        <Tooltip style={{ backgroundColor: '#272c36 !important' }}>
                          คลิกเพื่อแสดงรายละเอียด
                        </Tooltip>
                      }
                    >
                      <span
                        onClick={() => {
                          handleShowWarningDetail(rowData)
                        }}
                        style={{
                          cursor: 'pointer',
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingTop: 3,
                          paddingBottom: 3,
                          fontWeight: 'bold',
                          color: 'red',
                        }}
                      >
                        <Icon
                          // size="sm"
                          className="animation"
                          style={{ color: '#F44336' }}
                          icon={'exclamation-triangle'}
                        />
                        {`   คลิก`}
                      </span>
                    </Whisper>
                  </>
                )
              }

              if (rowData.isDisplayWarning == 'NO' && rowData.countStatusStickyNote > 0) {
                return (
                  <>
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={
                        <Tooltip style={{ backgroundColor: '#272c36 !important' }}>
                          คลิกเพื่อแสดงรายละเอียด
                        </Tooltip>
                      }
                    >
                      <span
                        onClick={() => {
                          handleShowWarningDetail(rowData)
                        }}
                        style={{
                          cursor: 'pointer',
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingTop: 3,
                          paddingBottom: 3,
                          fontWeight: 'bold',
                          color: '#2da888',
                        }}
                      >
                        {`   คลิก`}
                      </span>
                    </Whisper>
                  </>
                )
              }

              return ''
            }}
          </Cell>
        </Column>

        {/* <Column width={230} minWidth={230} flexGrow> */}
        <Column
          width={fs < 16 ? 220 : fs <= 19 ? 260 : 300}
          minWidth={fs < 16 ? 220 : fs <= 19 ? 260 : 300}
          flexGrow
        >
          <HeaderCell style={{ ...styleHeaderCell }}>วันที่เริ่มต้น - วันที่สิ้นสุด</HeaderCell>
          <Cell dataKey="startAndEndDate" />
        </Column>

        <Column width={200} align="right">
          <HeaderCell>
            <div style={{ ...styleHeaderCell }}>จำนวนเงินงวด (บาท)</div>
          </HeaderCell>
          {/* <Cell style={{ textAlign: 'right' }} dataKey="budgetOfPeriod" /> */}
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.budgetOfPeriod || 0)
            }}
          </Cell>
        </Column>

        <Column width={200} align={'center'}>
          <HeaderCell style={{ ...styleHeaderCell }}>สถานะงวด</HeaderCell>
          {/* <Cell dataKey="periodStatus" /> */}
          <TagCell dataKey="periodStatus" />
        </Column>

        <Column
          width={
            fs < 15
              ? disabled
                ? 115
                : 230
              : fs < 18
                ? disabled
                  ? 135
                  : 270
                : disabled
                  ? 145
                  : 290
          }
          // align="center"
          // fixed="right"
        >
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ViewButton
                    icon="eye"
                    onClick={() => {
                      onSelect(rowData)
                    }}
                  >
                    แสดง
                  </ViewButton>
                  {!disabled && (
                    <SaveButton
                      icon="cog"
                      onClick={() => {
                        onSelectPeriodicManagement(rowData)
                      }}
                      style={{}}
                    >
                      จัดการงวด
                    </SaveButton>
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <WarningDetailWidgets
        show={isShowModalWarning}
        projectCode={warningProjectCode}
        periodNumber={warningPeriodNumber}
        onCancle={() => {
          onReload()
          setIsShowModalWarning(false)
        }}
      />
    </>
  )
}
